/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { hooksGetStatus } from "../funcs/hooksGetStatus.js";
import { hooksHooksNumberClaude } from "../funcs/hooksHooksNumberClaude.js";
import { hooksHooksNumberCodex } from "../funcs/hooksHooksNumberCodex.js";
import { hooksHooksNumberCursor } from "../funcs/hooksHooksNumberCursor.js";
import { hooksHooksNumberLogs } from "../funcs/hooksHooksNumberLogs.js";
import { hooksHooksNumberMetrics } from "../funcs/hooksHooksNumberMetrics.js";
import { hooksIngest } from "../funcs/hooksIngest.js";
import { hooksSkillFeedback } from "../funcs/hooksSkillFeedback.js";
import { hooksUploadSkillContent } from "../funcs/hooksUploadSkillContent.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ClaudeHookResult } from "../models/components/claudehookresult.js";
import { CodexHookResult } from "../models/components/codexhookresult.js";
import { CursorHookResult } from "../models/components/cursorhookresult.js";
import { HooksStatus } from "../models/components/hooksstatus.js";
import { IngestHookResult } from "../models/components/ingesthookresult.js";
import {
  GetHooksStatusRequest,
  GetHooksStatusSecurity,
} from "../models/operations/gethooksstatus.js";
import { HooksNumberClaudeRequest } from "../models/operations/hooksnumberclaude.js";
import {
  HooksNumberCodexRequest,
  HooksNumberCodexSecurity,
} from "../models/operations/hooksnumbercodex.js";
import {
  HooksNumberCursorRequest,
  HooksNumberCursorSecurity,
} from "../models/operations/hooksnumbercursor.js";
import {
  HooksNumberLogsRequest,
  HooksNumberLogsSecurity,
} from "../models/operations/hooksnumberlogs.js";
import {
  HooksNumberMetricsRequest,
  HooksNumberMetricsSecurity,
} from "../models/operations/hooksnumbermetrics.js";
import { IngestHookEventRequest } from "../models/operations/ingesthookevent.js";
import {
  SkillFeedbackRequest,
  SkillFeedbackSecurity,
} from "../models/operations/skillfeedback.js";
import {
  UploadSkillContentRequest,
  UploadSkillContentSecurity,
} from "../models/operations/uploadskillcontent.js";
import { unwrapAsync } from "../types/fp.js";

export class Hooks extends ClientSDK {
  /**
   * claude hooks
   *
   * @remarks
   * Unified endpoint for all Claude Code hook events. Handles SessionStart, PreToolUse, PostToolUse, and PostToolUseFailure.
   */
  async hooksNumberClaude(
    request: HooksNumberClaudeRequest,
    options?: RequestOptions,
  ): Promise<ClaudeHookResult> {
    return unwrapAsync(hooksHooksNumberClaude(
      this,
      request,
      options,
    ));
  }

  /**
   * codex hooks
   *
   * @remarks
   * Endpoint for Codex hook events. Handles SessionStart, PreToolUse, PermissionRequest, PostToolUse, UserPromptSubmit, and Stop.
   */
  async hooksNumberCodex(
    request: HooksNumberCodexRequest,
    security?: HooksNumberCodexSecurity | undefined,
    options?: RequestOptions,
  ): Promise<CodexHookResult> {
    return unwrapAsync(hooksHooksNumberCodex(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * cursor hooks
   *
   * @remarks
   * Endpoint for Cursor hook events. Handles beforeSubmitPrompt, stop, afterAgentResponse, afterAgentThought, preToolUse, postToolUse, postToolUseFailure, beforeMCPExecution, and afterMCPExecution.
   */
  async hooksNumberCursor(
    request: HooksNumberCursorRequest,
    security?: HooksNumberCursorSecurity | undefined,
    options?: RequestOptions,
  ): Promise<CursorHookResult> {
    return unwrapAsync(hooksHooksNumberCursor(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getStatus hooks
   *
   * @remarks
   * Report whether the organization has any hook telemetry source configured. Reads configuration only; it does not query hook traffic.
   */
  async getStatus(
    request?: GetHooksStatusRequest | undefined,
    security?: GetHooksStatusSecurity | undefined,
    options?: RequestOptions,
  ): Promise<HooksStatus> {
    return unwrapAsync(hooksGetStatus(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * ingest hooks
   *
   * @remarks
   * Feature-first unified endpoint for hook events from supported coding assistants.
   */
  async ingest(
    request: IngestHookEventRequest,
    options?: RequestOptions,
  ): Promise<IngestHookResult> {
    return unwrapAsync(hooksIngest(
      this,
      request,
      options,
    ));
  }

  /**
   * logs hooks
   *
   * @remarks
   * Endpoint to receive OTEL logs data from Claude Code. Requires API key authentication, or a device-agent token from a headless device enrolled as a workload.
   */
  async hooksNumberLogs(
    request: HooksNumberLogsRequest,
    security?: HooksNumberLogsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(hooksHooksNumberLogs(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * metrics hooks
   *
   * @remarks
   * Endpoint to receive OTEL metrics data from Claude Code. Requires API key authentication, or a device-agent token from a headless device enrolled as a workload.
   */
  async hooksNumberMetrics(
    request: HooksNumberMetricsRequest,
    security?: HooksNumberMetricsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(hooksHooksNumberMetrics(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * skillFeedback hooks
   *
   * @remarks
   * Records agent-volunteered feedback about a distributed skill.
   */
  async skillFeedback(
    request: SkillFeedbackRequest,
    security?: SkillFeedbackSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(hooksSkillFeedback(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * uploadSkillContent hooks
   *
   * @remarks
   * Uploads skill manifest content requested by the unified hook ingest endpoint.
   */
  async uploadSkillContent(
    request: UploadSkillContentRequest,
    security?: UploadSkillContentSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(hooksUploadSkillContent(
      this,
      request,
      security,
      options,
    ));
  }
}
